export function hasEditorAccess(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  const storage = window.localStorage;
  if (!storage || typeof storage.getItem !== "function") {
    return false;
  }

  try {
    return storage.getItem("editorAccess") === "true";
  } catch {
    return false;
  }
}
